import { ethers } from 'ethers';
import { CURRENT_NETWORK } from '../config/networks';

// Read-only JsonRpcProvider for the active network
let readProvider = null;
export function getReadProvider() {
  if (readProvider) return readProvider;
  readProvider = new ethers.providers.JsonRpcProvider(CURRENT_NETWORK.rpcUrls[0]);
  return readProvider;
}

// Wrap injected provider as ethers Web3Provider
export function getWeb3Provider(injected) {
  if (!injected) return null;
  return new ethers.providers.Web3Provider(injected, 'any');
}

// Map contract short error codes → friendly messages
const ERROR_MAP = {
  'TE':     'Too early — 24h cycle not yet complete.',
  'NA':     'No active mining machines.',
  'NR':     'You are not registered.',
  'BL':     'This account is blacklisted.',
  'REG':    'Already registered.',
  'IDX':    'Invalid tier index.',
  'TIER':   'Package tier is not active.',
  'IR':     'Invalid referrer / sponsor.',
  'TF':     'USDT transfer failed. Check approval.',
  'MIN':    'Amount is below the minimum withdrawal.',
  'PB':     'Insufficient pending balance.',
  'OOA':    'Only owner or admin can perform this action.',
  'OW':     'Only owner can perform this action.',
  'OL':     'Only the Logic contract can call this function.',
  'IA':     'Invalid address.',
  'IT':     'Invalid token address.',
  'IW':     'Invalid wallet address.',
  'PD':     'Placement depth must be 50–300.',
  'GD':     'Generation depth must be 5–30.',
  'FEE>30': 'Withdrawal fee cannot exceed 30%.',
  'INV':    'Invalid value.',
  'NF':     'Not found.',
  'BLAO':   'Cannot blacklist owner or admin.',
  'BPS>100':'Total distribution exceeds 100%.',
  'PB<0':   'Not enough pending balance.',
  'LEG<0':  'Not enough leg business.',
  'NAI':    'No active machines to compute mining from.',
};

function translateError(msg) {
  if (!msg) return msg;
  // Exact match on short code
  const trimmed = msg.trim();
  if (ERROR_MAP[trimmed]) return ERROR_MAP[trimmed];
  // Try to find a short code inside the message
  for (const key of Object.keys(ERROR_MAP)) {
    // Match key wrapped in quotes or as a standalone word
    const re = new RegExp(`(^|["'\\s(])${key.replace(/[><]/g, m => '\\' + m)}(["'\\s.)]|$)`);
    if (re.test(msg)) return ERROR_MAP[key];
  }
  return msg;
}

// Human-readable error extractor for wallet/tx errors
export function parseError(err) {
  if (!err) return 'Unknown error';

  if (typeof err === 'string') return translateError(err);

  // User rejected
  if (err.code === 4001 || err.code === 'ACTION_REJECTED') {
    return 'Transaction rejected.';
  }

  // Insufficient funds
  if (err.code === 'INSUFFICIENT_FUNDS') return 'Insufficient balance for gas.';

  // Nested reason
  if (err.reason) return translateError(err.reason);
  if (err.data && err.data.message) return translateError(err.data.message);
  if (err.error && err.error.message) return translateError(err.error.message);
  if (err.message) {
    let msg = err.message;
    msg = msg.replace(/execution reverted:?\s*/i, '');
    msg = msg.replace(/^\[.*?\]\s*/, '');
    if (msg.length > 140) msg = msg.slice(0, 140) + '…';
    return translateError(msg);
  }
  return 'Transaction failed';
}
